import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc1038',
    ecrans: ['00-2']
});
